<script>
  import { onMount } from 'svelte';
  import CourseResults from './CourseResults.svelte';
  import { getFilteredCourses, createFilterUrl} from './api';
  import { setApiUrl, getApiUrl, updateFilter,setCount} from './Common.svelte';
  import Toast from './Toast.svelte';

  let filteredCourses = [];
  export let courseSearchUrl;
  export let count;
  export let title;
  export let subTitle;
  export let layout; 
  export let cardHeight;
  export let coulmnCount;
  export let textSize;
  //console.log("recieved in APP:", layout);
  let showToast = false;
  let toastMessage = "";


  export let issetCenter;
  export let centerId;
  export let customPosts =[];
 
  setCount(count);
  setApiUrl(courseSearchUrl);

  let receivedDate;
  
  async function handleFilterChange(filterUrl) {
    if (filteredCourses.length == 0) {
      staticLoader()
      showToast = false;
    } else {
      filteredCourses.forEach(function(v, i) {
        filteredCourses[i].loading = true;
      });
    }
    filteredCourses = await getFilteredCourses(filterUrl);
    if (filteredCourses.length === 0){
      showToast = true;
      toastMessage = "No program found. Please change your search criteria and try again...";
    }else{
      showToast = false;
      toastMessage = "";
    }
		
  }
  function staticLoader() {
    let f = [];
    setApiUrl(courseSearchUrl);
    for (let index = 0; index < count; index++) {
      f.push({"loading":true});      
    }
    filteredCourses = f;
  }
  onMount(() => {
    const filterUrl = getApiUrl()
    handleFilterChange(filterUrl)
  });

  
  function handleDate(event) {
    receivedDate = event.detail.date;
    const filter = updateFilter(receivedDate)
    const filterUrl = createFilterUrl(getApiUrl(), filter)
    handleFilterChange(filterUrl)
  }
  let viewFilter = false;
  function onFilterClick () {
    viewFilter = !viewFilter;
  }
</script>


  
    
  
<div class="w-full">
    
    <div class="flex flex-col items-center justify-end">
      
      <!-- <DateFilter on:dateEvent={handleDate} /> -->
      {#if showToast}
      <Toast message={toastMessage} visible={showToast} />
      {/if}
      <CourseResults filteredCourses={filteredCourses} {layout} {cardHeight} {coulmnCount} {textSize}/>
    </div>
  </div>

<style>
  .filter-holder.hidden{
    display: none;
  }
  

  .fade-in {
    animation: fadeIn 0.5s;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>